import { faCalendar, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import Puja from '../../assets/images/login.png'
import Icon from '../Icon'
import { Link } from 'react-router-dom'
import { convertTo12HourFormat, dateFormat } from '../../utils'
import useWidth from '../../hooks/useWidth'

export default ({ data = {} }) => {
    const width = useWidth()

    return(
        <div className="card rounded-4 m-2 d-flex flex-row bg-light">
            <div className="p-3 d-flex flex-column justify-content-between" style={{ width: "60%" }}>
                <div>
                    <Link to={`/e-puja-details/${ data._id }`} className="mb-2 custom-text-color bold fs-5" style={{ lineHeight: 1}}>
                        { String(data.title).substring(0, 45) }
                    </Link>

                    <p className='mb-2 custom-text-color fs-9'>{ String(data.description).substring(0, width < 500 ? 120 : 300) }</p>
                    <p className='mb-0 custom-text-color fs-9 bold'><Icon icon={faCalendarAlt} className="me-2" />{ dateFormat(data.ePujaDate)}, { data.day } ( upto { data.end_at && convertTo12HourFormat(data.end_at) } ) </p>
                </div>
                <Link to={`/e-puja-details/${ data._id }`} >
                    <button className='primary-btn px-4 mt-3'>Book Now</button>
                </Link>
            </div>
            <div className='p-2' style={{ width: "50%", height: width < 500 ? "250px" : "300px" }}>
                <img src={data.files?.at(0)?.Url || Puja} className='w-100 rounded-4 h-100' style={{ objectFit: "cover", borderRadius: "0px 12px 12px 0px" }} />
            </div>
        </div>
    )
}